<template>
    <div class="qingwu">
        <el-form  label-width="100px" ref="info" :model="info">
            <el-form-item label-width="160px" label="每日签到奖励句豆奖励" prop="meirqd" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd"></el-input></el-form-item>
            <el-form-item label-width="160px" label="每日分享句签奖励" prop="meirfxjq" :rules="[{required:true,message:'每日分享句签奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirfxjq"></el-input></el-form-item>
            <el-form-item label-width="160px" label="每日首次发布内容奖励" prop="meirscfbnr" :rules="[{required:true,message:'每日首次发布内容奖励不能为空',trigger: 'blur' }]"><el-input  placeholder="请输入内容" v-model="info.meirscfbnr"></el-input></el-form-item>
            <el-form-item label-width="160px" label="每日首次评论别人内容奖励" prop="meirscplnr" :rules="[{required:true,message:'每日首次评论别人内容奖励不能为空',trigger: 'blur' }]"><el-input  placeholder="请输入内容" v-model="info.meirscplnr"></el-input></el-form-item>
            <el-form-item label-width="160px" label="浏览视频奖励" prop="liulsp" :rules="[{required:true,message:'浏览视频奖励不能为空',trigger: 'blur' }]"><el-input  placeholder="请输入内容" v-model="info.liulsp"></el-input></el-form-item>
            <el-form-item label-width="160px" label="首次建圈奖励" prop="shoucjq" :rules="[{required:true,message:'首次建圈奖励不能为空',trigger: 'blur' }]"><el-input  placeholder="请输入内容" v-model="info.shoucjq"></el-input></el-form-item>
            <el-form-item label-width="160px" label="备注："><el-tag type="info">任务奖励</el-tag></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第1天" prop="meirqd1" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd1"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第2天" prop="meirqd2" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd2"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第3天" prop="meirqd3" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd3"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第4天" prop="meirqd4" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd4"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第5天" prop="meirqd5" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd5"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第6天" prop="meirqd6" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd6"></el-input></el-form-item>
          <el-form-item label-width="160px" label="签到句豆奖励-第7天" prop="meirqd7" :rules="[{required:true,message:'每日签到奖励句豆奖励不能为空',trigger: 'blur' }]"><el-input placeholder="请输入内容" v-model="info.meirqd7"></el-input></el-form-item>
            <el-form-item label-width="160px">
                <el-button type="primary" @click="submitForm('info')">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          info:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        submitForm:function(e){
            this.$refs[e].validate(res=>{
                if(res){
                    // Http 请求
                    this.$post(this.$api.wxPayAppConfig,this.info).then(postRes=>{
                        if(postRes.code == 200){
                            this.$message.success("编辑成功");
                            this.get_wxpayapp_config();
                        }else{
                            this.$message.error("编辑失败");
                        }
                    });
                }
            });
        },
        get_wxpayapp_config(){
            this.$get(this.$api.wxPayAppConfig).then(res=>{
                if(res.data != null){
                    this.info  = res.data;
                }
            });
        },
    },
    created() {
        this.get_wxpayapp_config();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>

</style>